export enum PublishedStatusEnum {
    NotPublished = 'NotPublished',
    Published = 'Published',
}
